const model = {
    orderIn: [],
    loading: false,
    error: null,
    status: null,
};

export default model;